import { ProductImageRequestDto } from '@tiendanube/common';
import {
  DeleteImagesRequest,
  UpdateImagesRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/ImagesRequest';
import { ImageGalleryState } from 'domains/Catalog/Products/pages/components/ImageGallery/ImageGallery';

type ImagesPayload = (UpdateImagesRequest | DeleteImagesRequest)[];

export const generateImagesPayload = (
  originalImages: ImageGalleryState[],
  newImages: ProductImageRequestDto[],
): ImagesPayload => {
  const imagesToCreate: UpdateImagesRequest[] = [];
  const imagesToDelete: DeleteImagesRequest[] = [];

  const newIds = new Set(newImages.map((i) => String(i.image_id)));
  originalImages.forEach((image) => {
    if (!newIds.has(String(image.id))) {
      imagesToDelete.push({ id: Number(image.id), '@delete': true });
    }
  });

  newImages.forEach((image, index) => {
    imagesToCreate.push({
      id: Number(image.image_id),
      order: index,
    });
  });

  return [...imagesToCreate, ...imagesToDelete];
};
